import { http } from "@/shared/lib/api/http"
import type { ChurchFinanceOverview } from "@ibada/shared-types/overview"

/** ADR-0003 success envelope. */
type Envelope<T> = { data?: T | null }

export type ChurchFinanceQuery = {
  workspaceId: string
  dateFrom: string
  dateTo: string
}

/** `GET /finance/overview/church`: the church-wide board's own figures. Disclosure is decided server-side. */
export async function fetchChurchFinance(query: ChurchFinanceQuery): Promise<ChurchFinanceOverview> {
  const response = await http.get<Envelope<ChurchFinanceOverview>>("/finance/overview/church", { params: query })
  const data = response.data?.data
  if (!data) throw new Error("Church finance overview: empty response")
  return data
}
